module.exports = __webpack_public_path__ + "static/img/present_point_img.5d084e96.gif";